class BriefForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.endpoint = this.dataset.endpoint;

    if (!this.form) return;

    this.sourceField = this.form.querySelector('[data-brief-source]');
    this.imageField = this.form.querySelector('[data-brief-image]');
    this.submitButton = this.form.querySelector('[type="submit"]');

    this.setSource();
    this.form.addEventListener('change', this.handleChange.bind(this));
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  connectedCallback() {
    const dialog = this.querySelector('[data-brief-success]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    dialog.querySelector('[data-brief-success-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.showModal();
  }

  setSource() {
    if (!this.sourceField) return;

    const params = new URLSearchParams(window.location.search);
    this.sourceField.value = params.get('sursa') || document.referrer || window.location.pathname;
  }

  handleChange(event) {
    const target = event.target;

    if (this.imageField && target.matches('[data-brief-image-url]')) {
      this.imageField.value = target.dataset.briefImageUrl;
    }

    if (target.matches('[data-brief-option]')) {
      this.syncGroup(target.dataset.briefOption);
    }
  }

  syncGroup(groupId) {
    const field = this.form.querySelector(`[data-brief-group="${groupId}"]`);
    if (!field) return;

    const checked = this.form.querySelectorAll(`[data-brief-option="${groupId}"]:checked`);
    field.value = Array.from(checked)
      .map((input) => input.value)
      .join(', ');
  }

  handleSubmit() {
    if (this.submitButton) {
      this.submitButton.disabled = true;
    }

    this.mirrorToSheet();
  }

  /**
   * sendBeacon, nu fetch: cererea trebuie sa supravietuiasca navigarii pe care
   * o face imediat formularul catre /contact. O singura incercare, fara retry,
   * altfel raspunsul ar ajunge de doua ori in tabel.
   */
  mirrorToSheet() {
    if (!this.endpoint) return;

    const payload = this.buildPayload();
    const blob = new Blob([JSON.stringify(payload)], { type: 'text/plain;charset=utf-8' });

    try {
      navigator.sendBeacon(this.endpoint, blob);
    } catch (error) {
      // raspunsul ajunge oricum pe email prin formularul Shopify
    }
  }

  buildPayload() {
    const payload = {};

    new FormData(this.form).forEach((value, key) => {
      const match = key.match(/^contact\[(.+?)\]$/);
      if (!match) return;

      const name = this.form.elements[key]?.dataset?.briefLabel || match[1];
      if (value === '') return;

      if (payload[name] === undefined) {
        payload[name] = value;
      } else {
        payload[name] = `${payload[name]}, ${value}`;
      }
    });

    if (payload['Poza varianta']) {
      payload['Poza varianta'] = `=IMAGE("${payload['Poza varianta']}")`;
    }

    return payload;
  }
}

customElements.define('brief-form', BriefForm);
